import React from "react";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";


export const NotificationEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-14 h-14 bg-gradient-to-br from-blue-50 to-blue-100 rounded-full flex items-center justify-center mb-3 ring-1 ring-blue-200">
        <Bell className="w-7 h-7 text-blue-400" />
      </div>

      <p className="text-center text-gray-900 font-semibold mb-1 text-sm">
        {t("notifications.empty.title", "No notifications")}
      </p>

      <p className="text-center text-gray-500 text-sm max-w-xs leading-relaxed">
        {t("notifications.empty.description", "You're all caught up! Check back later for updates.")}
      </p>
    </div>
  );
};
